const ReplyModal = ({ inquiry, replyMessage, setReplyMessage, onSubmit, onCancel }) => {
  if (!inquiry) return null;

  return (
    <div
      className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50 p-4"
      data-testid="reply-modal"
    >
      <div className="bg-ewss-navy border border-ewss-cyan/30 rounded-2xl p-8 max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <h2 className="text-2xl font-bold text-white mb-4">Reply to Inquiry</h2>

        <div className="mb-4 p-4 bg-black/40 rounded-lg">
          <p className="text-sm text-gray-400 mb-1">From:</p>
          <p className="text-white font-semibold">
            {inquiry.name} ({inquiry.email})
          </p>
          <p className="text-sm text-gray-400 mt-2 mb-1">Subject:</p>
          <p className="text-white">{inquiry.subject}</p>
          <p className="text-sm text-gray-400 mt-2 mb-1">Message:</p>
          <p className="text-gray-300 whitespace-pre-wrap">{inquiry.message}</p>
        </div>

        <div className="mb-4">
          <label className="block text-white font-medium mb-2">Your Reply:</label>
          <textarea
            value={replyMessage}
            onChange={(e) => setReplyMessage(e.target.value)}
            rows={8}
            className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-ewss-cyan transition-colors resize-none"
            placeholder="Type your reply here... (Will be saved to database. You can respond to customer via email at info@ewss.co.za)"
            data-testid="reply-modal-textarea"
          />
        </div>

        <div className="bg-yellow-500/10 border border-yellow-500/30 rounded-lg p-4 mb-4">
          <p className="text-yellow-400 text-sm">
            ℹ️ Note: Reply will be saved to the database. Please respond to the customer directly
            via email at <strong>info@ewss.co.za</strong>
          </p>
        </div>

        <div className="flex gap-3">
          <button
            onClick={onSubmit}
            className="flex-1 px-6 py-3 bg-ewss-cyan text-ewss-navy font-semibold rounded-lg hover:shadow-[0_0_30px_rgba(23,145,255,0.5)] transition-all duration-300"
            data-testid="reply-modal-submit"
          >
            Save Reply
          </button>
          <button
            onClick={onCancel}
            className="px-6 py-3 border border-gray-600 text-white rounded-lg hover:bg-white/5 transition-colors"
            data-testid="reply-modal-cancel"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReplyModal;
